import {Step, useTheme} from '@mui/material';
import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {PlanTypeEnum, SelectionFlowEnum} from 'presentation/constants';

import {ProductLogo, TagChip} from 'presentation/components';
import {formatText} from 'presentation/utils';

import {ChangePlanDialog} from 'presentation/components/ChangePlanDialog';
import {planTypeOptions} from '../../constants';

import {useSteps} from '../../hooks/useSteps';
import {useIsComingFromInitialFlowStore} from '../../store/useIsComingFromInitialFlowStore';
import {useSelectedBeneficiaryStore} from '../../store/useSelectedBeneficiaryStore';
import {useSelectedPlanStore} from '../../store/useSelectedPlanStore';
import {StepContent} from '../StepContent';
import {Container, StepperStyled} from './styles';

export function SelectionSideContent() {
	const {colors} = useTheme();
	const selectedPlan = useSelectedPlanStore(state => state.selectedPlan);
	const {currentStep, steps} = useSteps();
	const navigate = useNavigate();
	const resetSelectedBeneficiary = useSelectedBeneficiaryStore(
		state => state.resetSelectedBeneficiary,
	);
	const {state} = useLocation();

	const [showChangePlanDialogState, setShowChangePlanDialogState] = useState<boolean>(false);
	const isComingFromInitialFlow = useIsComingFromInitialFlowStore(
		currentState => currentState.isComingFromInitialFlow,
	);

	const handleGoToPlanSelection = () => {
		if (isComingFromInitialFlow) {
			setShowChangePlanDialogState(true);
			return;
		}
		resetSelectedBeneficiary();
		navigate(SelectionFlowEnum.PLAN_SELECTION, {
			state: {
				...state,
				isCommingFromLoginPaths: true,
			},
		});
	};

	const handleGoToBeneficiarySelection = () => {
		resetSelectedBeneficiary();
		navigate(SelectionFlowEnum.BENEFICIARY_SELECTION, {
			state: {
				...state,
				isCommingFromLoginPaths: true,
			},
		});
	};

	const stepButtonAction = [handleGoToPlanSelection, handleGoToBeneficiarySelection];

	return (
		<Container square>
			<ProductLogo />
			<StepperStyled activeStep={currentStep.stepNumber - 1} orientation="vertical">
				{steps.map(({stepNumber, label, selectedItemLabel, buttonLabel}, index) => (
					<Step key={label}>
						<StepContent
							completed={currentStep.stepNumber - 1 > index}
							buttonAction={stepButtonAction[index]}
							buttonLabel={buttonLabel}
							description={
								index === 0 ? selectedItemLabel : formatText(selectedItemLabel)
							}
							label={label}
							footer={
								stepNumber === 1 && selectedPlan ? (
									<TagChip
										label={planTypeOptions[selectedPlan?.tipoPlanoC]?.label}
										color={planTypeOptions[selectedPlan?.tipoPlanoC]?.color}
										bgColor={
											selectedPlan?.tipoPlanoC === PlanTypeEnum.HEALTH
												? colors.light.primary['30Percent']
												: undefined
										}
										data-testid="plan-chip-side-content"
									/>
								) : null
							}
						/>
					</Step>
				))}
			</StepperStyled>
			<ChangePlanDialog
				open={showChangePlanDialogState}
				setOpen={setShowChangePlanDialogState}
			/>
		</Container>
	);
}
